import { motion } from "motion/react";
import { MessageCircle } from "lucide-react";
import { CONTACT_INFO } from "@/constants/company";

/**
 * Botón flotante de WhatsApp
 * Animación de entrada con spring y efecto hover
 */
export function WhatsAppButton() {
  return (
    <motion.a
      href={CONTACT_INFO.whatsapp.url}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        duration: 0.5,
        delay: 1.5,
        type: "spring",
        stiffness: 200,
      }}
      whileHover={{ scale: 1.12 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-24 md:bottom-8 right-6 md:right-8 z-40 bg-[#25D366] text-white p-4 rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.45)] hover:bg-[#20B45B] z-[90] flex items-center justify-center transition-colors"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-8 h-8" />
    </motion.a>
  );
}
